module.exports = __webpack_public_path__ + "static/media/riosanlorenzo.6b10e491.jpg";